import { render, staticRenderFns } from "./WidgetChatBox.vue?vue&type=template&id=048a7afe&"
import script from "./WidgetChatBox.vue?vue&type=script&lang=js&"
export * from "./WidgetChatBox.vue?vue&type=script&lang=js&"
import style0 from "./WidgetChatBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports